// extracted by mini-css-extract-plugin
module.exports = {"inductee-landing-loader":"InducteeLandingLoader_inductee-landing-loader__gjldm","spinner":"InducteeLandingLoader_spinner__IZXxh"};